
const Dashboard = () => {
    return (
        <div className="page-content">
            <h1>Dashboard Enquêtes</h1>
            <p>Bienvenue sur le tableau de bord.</p>
        </div>
    );
};

export default Dashboard;